module.exports = __webpack_public_path__ + "img/v_pass.9d4c5bda.svg";